module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Pride-And-Prejudice-landscape.828ed86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Pride-And-Prejudice-landscape.jpg
// module id = OJB6
// module chunks = 0